const TAILWIND_CONTAINER_4XL_REM = 56;
const TAILWIND_CONTAINER_5XL_REM = 64;

/** Fold points are Tailwind container sizes; at each one every pane's minimum fits its maximum share, and both panes plus the record's minimum fit together. */
export const DETAIL_LAYOUT_PANE_SIZES = {
  left: {
    defaultSize: '24%',
    minSize: '15rem',
    maxSize: '30%',
    foldRem: TAILWIND_CONTAINER_4XL_REM,
    foldBesideRightPaneRem: TAILWIND_CONTAINER_5XL_REM,
  },
  right: {
    defaultSize: '28%',
    minSize: '22rem',
    maxSize: '40%',
    foldRem: TAILWIND_CONTAINER_4XL_REM,
  },
  record: { minSize: '24rem' },
} as const;
